export const SvgStep1 = () => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 49 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dddii_1383_9813)">
        <circle
          cx="23.8931"
          cy="24.2076"
          r="17.104"
          fill="url(#paint0_linear_1383_9813)"
        />
      </g>
      <g clipPath="url(#clip0_1383_9813)">
        <path
          d="M28.5816 23.2662C28.8267 23.0211 29.2242 23.0211 29.4693 23.2662C29.7519 23.5488 29.9729 23.8833 30.135 24.2617C30.3115 24.6735 30.3633 25.0746 30.3633 25.4855C30.3633 25.8964 30.3115 26.2974 30.135 26.7092C29.9729 27.0876 29.7519 27.4222 29.4693 27.7048C29.1867 27.9874 28.8522 28.2083 28.4738 28.3705C28.0671 28.5448 27.671 28.5975 27.2655 28.5988L26.3478 28.6425C26.3378 28.643 26.3279 28.6432 26.3179 28.6432H23.4772C23.0663 28.6432 22.6653 28.5914 22.2535 28.4149C21.8751 28.2527 21.5405 28.0318 21.2579 27.7492C20.9753 27.4665 20.7544 27.132 20.5922 26.7536C20.4157 26.3418 20.3639 25.9408 20.3639 25.5299C20.3639 25.119 20.4157 24.7179 20.5922 24.3061C20.7575 23.9204 20.9808 23.5877 21.3023 23.2662C21.5849 22.9836 21.9194 22.7626 22.2978 22.6005C22.7097 22.424 23.1107 22.3722 23.5216 22.3722L24.4981 22.3722C24.8448 22.3722 25.1258 22.6532 25.1258 22.9999C25.1258 23.3466 24.8448 23.6276 24.4981 23.6276L23.5216 23.6276C23.2223 23.6276 23.002 23.6646 22.7924 23.7544C22.5494 23.8585 22.3513 23.9927 22.19 24.1539C21.9789 24.365 21.8471 24.5649 21.7461 24.8007C21.6563 25.0102 21.6193 25.2306 21.6193 25.5299C21.6193 25.8291 21.6563 26.0495 21.7461 26.2591C21.8502 26.5021 21.9844 26.7002 22.1456 26.8615C22.3069 27.0227 22.505 27.1568 22.748 27.261C22.9576 27.3508 23.178 27.3878 23.4772 27.3878L26.303 27.3878L27.2202 27.3441C27.2301 27.3436 27.2401 27.3434 27.25 27.3434C27.5493 27.3434 27.7697 27.3064 27.9792 27.2166C28.2222 27.1125 28.4204 26.9783 28.5816 26.8171C28.7428 26.6558 28.877 26.4577 28.9811 26.2147C29.071 26.0051 29.1079 25.7847 29.1079 25.4855C29.1079 25.1862 29.071 24.9659 28.9811 24.7563C28.877 24.5133 28.7428 24.3151 28.5816 24.1539C28.3365 23.9088 28.3365 23.5113 28.5816 23.2662ZM25.7409 21.7571C25.5797 21.5958 25.3815 21.4617 25.1385 21.3575C24.929 21.2677 24.7086 21.2307 24.4093 21.2307L21.4948 21.2307L20.5776 21.2744C20.5677 21.2749 20.5577 21.2751 20.5477 21.2751C20.2485 21.2751 20.0281 21.3121 19.8185 21.4019C19.5755 21.5061 19.3774 21.6402 19.2162 21.8015C19.0549 21.9627 18.9208 22.1608 18.8166 22.4038C18.7268 22.6134 18.6898 22.8338 18.6898 23.133C18.6898 23.4323 18.7268 23.6527 18.8166 23.8623C18.9208 24.1053 19.0549 24.3034 19.2162 24.4646C19.4613 24.7097 19.4613 25.1072 19.2162 25.3523C18.971 25.5975 18.5736 25.5975 18.3284 25.3523C18.0458 25.0697 17.8249 24.7352 17.6627 24.3568C17.4862 23.945 17.4344 23.5439 17.4344 23.133C17.4344 22.7221 17.4862 22.3211 17.6627 21.9093C17.8249 21.5309 18.0458 21.1964 18.3284 20.9137C18.6111 20.6311 18.9456 20.4102 19.324 20.248C19.7306 20.0737 20.1268 20.021 20.5323 20.0197L21.45 19.976C21.4599 19.9756 21.4699 19.9753 21.4798 19.9753L24.4093 19.9753C24.8202 19.9753 25.2213 20.0271 25.6331 20.2036C26.0115 20.3658 26.346 20.5867 26.6286 20.8694C26.9112 21.152 27.1322 21.4865 27.2943 21.8649C27.4708 22.2767 27.5226 22.6777 27.5226 23.0886C27.5226 23.4996 27.4708 23.9006 27.2943 24.3124C27.1322 24.6908 26.9112 25.0253 26.6286 25.3079C26.346 25.5906 26.0115 25.8115 25.6331 25.9737C25.226 26.1481 24.8294 26.2008 24.4234 26.202L23.4157 26.2458C23.0694 26.2608 22.7764 25.9923 22.7613 25.6459C22.7463 25.2996 23.0148 25.0066 23.3612 24.9915L24.3821 24.9471C24.3911 24.9467 24.4002 24.9465 24.4093 24.9465C24.7086 24.9465 24.929 24.9096 25.1385 24.8198C25.3815 24.7156 25.5797 24.5815 25.7409 24.4202C25.9021 24.259 26.0363 24.0609 26.1404 23.8179C26.2303 23.6083 26.2672 23.3879 26.2672 23.0886C26.2672 22.7894 26.2303 22.569 26.1404 22.3594C26.0363 22.1164 25.9021 21.9183 25.7409 21.7571Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dddii_1383_9813"
          x="0.182353"
          y="0.496806"
          width="48.596"
          height="48.5969"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.20224" dy="2.20224" />
          <feGaussianBlur stdDeviation="2.7895" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1383_9813"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.20224" dy="-2.20224" />
          <feGaussianBlur stdDeviation="2.20224" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.305882 0 0 0 0 0.305882 0 0 0 0 0.305882 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1383_9813"
            result="effect2_dropShadow_1383_9813"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2.20224" dy="2.20224" />
          <feGaussianBlur stdDeviation="2.20224" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.305882 0 0 0 0 0.305882 0 0 0 0 0.305882 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_1383_9813"
            result="effect3_dropShadow_1383_9813"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_1383_9813"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.146816" dy="-0.146816" />
          <feGaussianBlur stdDeviation="0.146816" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.305882 0 0 0 0 0.305882 0 0 0 0 0.305882 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect4_innerShadow_1383_9813"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.146816" dy="0.146816" />
          <feGaussianBlur stdDeviation="0.146816" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_innerShadow_1383_9813"
            result="effect5_innerShadow_1383_9813"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1383_9813"
          x1="6.78906"
          y1="7.10352"
          x2="40.9971"
          y2="41.3116"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1F1F1F" />
          <stop offset="1" stopColor="#282828" />
        </linearGradient>
        <clipPath id="clip0_1383_9813">
          <rect
            width="15.0651"
            height="15.0651"
            fill="white"
            transform="translate(24.0547 13.4121) rotate(45)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
